import { css, cx } from 'styled-system/css';
import { buttondownSubscribeUrl } from '../../newsletter/buttondownEnv';
import { accessCtaClass } from './AccessCta';

export function AccessSignupForm({
  idPrefix,
  className,
}: {
  idPrefix: string;
  className?: string;
}) {
  const subscribeUrl = buttondownSubscribeUrl();
  const emailId = `${idPrefix}-email`;

  if (!subscribeUrl) {
    return (
      <p
        className={cx(
          css({
            margin: '0',
            color: 'text.muted',
            fontSize: 'sm',
            lineHeight: 'relaxed',
            textWrap: 'pretty',
          }),
          className,
        )}
      >
        Early-access signup is temporarily unavailable. Please check back soon.
      </p>
    );
  }

  return (
    <form
      action={subscribeUrl}
      method="post"
      aria-label="Request early access"
      className={cx(
        css({
          display: 'flex',
          flexDirection: { base: 'column', sm: 'row' },
          gap: '3',
          width: '100%',
          maxWidth: '480px',
        }),
        className,
      )}
    >
      <input type="hidden" name="embed" value="1" />
      <label htmlFor={emailId} className={css({ srOnly: true })}>
        Work email
      </label>
      <input
        id={emailId}
        name="email"
        type="email"
        required
        placeholder="you@company.com"
        autoComplete="email"
        className={css({
          flex: { base: '0 0 auto', sm: '1 1 0%' },
          minHeight: '48px',
          height: '48px',
          paddingInline: '4',
          fontFamily: 'mono',
          fontSize: 'sm',
          color: 'text.primary',
          background: 'bg.surface',
          border: '1px solid',
          borderColor: 'border.hairline',
          outline: 'none',
          _placeholder: { color: 'text.faint' },
          _focus: { borderColor: 'border.strong' },
          _focusVisible: {
            outline: '2px solid token(colors.border.focus)',
            outlineOffset: '2px',
          },
        })}
      />
      <button type="submit" className={accessCtaClass('lg')}>
        Join waitlist
      </button>
    </form>
  );
}
